// Leaf - Event - select_variant - Start


(function () {
    if (window.location.pathname !== '/products/suri-2-sonic-toothbrush-uv-c-led-case') return;
  
    function getProductData() {
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product
      ) {
        var p = window.ShopifyAnalytics.meta.product;
        var productName = null;
        if (p.variants && p.variants.length > 0 && p.variants[0].name) {
          var variantName = p.variants[0].name;
          var dashIdx = variantName.indexOf(' - ');
          productName = dashIdx !== -1 ? variantName.substring(0, dashIdx) : variantName;
        }
        return { product_id: p.id, product_name: productName };
      }
  
      var jsonLdEl = document.querySelector('script[type="application/ld+json"]');
      if (jsonLdEl) {
        try {
          var data = JSON.parse(jsonLdEl.textContent);
          if (data['@type'] === 'Product') {
            return { product_id: data.productID || data.sku || null, product_name: data.name || null };
          }
        } catch (e) {}
      }
  
      return { product_id: null, product_name: null };
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isColourInput(input) {
      if (!input.dataset.optionValue) return false;
      if (input.dataset.frontendHidden === 'true') return false;
      var group = input.closest('.product_variant_option');
      if (!group) return false;
      var optionName = (group.dataset.optionName || '').toLowerCase();
      return optionName === 'colour' || optionName === 'color' ||
             optionName.includes('colour') || optionName.includes('color');
    }
  
    function init() {
      var productData = getProductData();
  
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
        if (!isColourInput(input)) return;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_variant',
          variant_type: 'device_colour',
          variant_value: normalizeValue(input.dataset.optionValue),
          product_id: productData.product_id,
          product_name: productData.product_name
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_variant - End
  
  // Leaf - Event - select_heads - Start
  
  (function () {
    if (window.location.pathname !== '/products/suri-2-sonic-toothbrush-uv-c-led-case') return;
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function init() {
      document.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
  
        if (!('bundleOption' in input.dataset)) return;
  
        var optionValue = input.dataset.optionValue;
        if (!optionValue) return;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_heads',
          heads_plan: normalizeValue(optionValue),
          quantity: 1
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_heads - End
  
  // Leaf - Event - select_plan - Start
  
  (function () {
    if (window.location.pathname !== '/products/suri-2-sonic-toothbrush-uv-c-led-case') return;
  
    function getProductId() {
      if (
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product
      ) {
        return window.ShopifyAnalytics.meta.product.id;
      }
  
      var jsonLdEl = document.querySelector('script[type="application/ld+json"]');
      if (jsonLdEl) {
        try {
          var data = JSON.parse(jsonLdEl.textContent);
          if (data['@type'] === 'Product') {
            return data.productID || data.sku || null;
          }
        } catch (e) {}
      }
  
      return null;
    }
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function isOneTimeInput(input) {
      if (input.id && input.id.endsWith('-buy_once')) return true;
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      if (input.id && /-sub(-\d+)?$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function getPlanFrequency(input) {
      var wrapper = input.closest('.subscription-options-block');
      if (!wrapper) return 'na';
  
      var interval = wrapper.dataset.mainDeliveryInterval;
      if (interval && interval.trim()) return normalizeValue(interval);
  
      var recurrence = wrapper.dataset.recurrenceLabel;
      if (recurrence && recurrence.trim()) return normalizeValue(recurrence);
  
      return 'na';
    }
  
    function init() {
      var productId = getProductId();
  
      document.addEventListener('change', function (e) {
        if (!e.isTrusted) return;
        var input = e.target;
        if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
  
        var wrapper = input.closest('.subscription-options-block');
        if (!wrapper) return;
  
        var planType, planFrequency;
  
        if (isOneTimeInput(input)) {
          planType = 'one_time';
          planFrequency = 'na';
        } else if (isSubscribeInput(input)) {
          planType = 'subscribe';
          planFrequency = getPlanFrequency(input);
        } else {
          return;
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'select_plan',
          plan_type: planType,
          plan_frequency: planFrequency,
          product_id: productId
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - select_plan - End
  
  // Leaf - Event - add_to_cart_sonic_brush - Start
  
  (function () {
    if (window.location.pathname !== '/products/suri-2-sonic-toothbrush-uv-c-led-case') return;
  
    var CURRENCY = 'GBP';
  
    function normalizeValue(value) {
      return value
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '')
        .replace(/_+/g, '_');
    }
  
    function getMainProduct() {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product;
      }
      return null;
    }
  
    function getProductTitle() {
      var product = getMainProduct();
      if (product && product.variants && product.variants.length > 0 && product.variants[0].name) {
        var name = product.variants[0].name;
        var dash = name.indexOf(' - ');
        return dash !== -1 ? name.substring(0, dash) : name;
      }
      return null;
    }
  
    function getVariantSku(variantId) {
      var product = getMainProduct();
      if (product && product.variants) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(variantId) && product.variants[i].sku) {
            return product.variants[i].sku;
          }
        }
      }
      return variantId;
    }
  
    function getVariantTitle(variantId) {
      var product = getMainProduct();
      if (product && product.variants) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(variantId)) {
            return product.variants[i].title || null;
          }
        }
      }
      return null;
    }
  
    function isMainProductVariant(variantId) {
      var product = getMainProduct();
      if (!product || !product.variants) return false;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) return true;
      }
      return false;
    }
  
    function isOneTimeInput(input) {
      if (input.id && input.id.endsWith('-buy_once')) return true;
      if (input.classList.contains('no-subscription-input')) return true;
      return false;
    }
  
    function isSubscribeInput(input) {
      if (input.id && input.id.endsWith('-buy_plan')) return true;
      if (input.id && /-sub(-\d+)?$/.test(input.id) && !/-no-sub/.test(input.id)) return true;
      return false;
    }
  
    function getPlanType() {
      var subBlocks = document.querySelectorAll('.subscription-options-block');
      for (var i = 0; i < subBlocks.length; i++) {
        var checkedInput = subBlocks[i].querySelector('input[type="radio"]:checked');
        if (!checkedInput) continue;
        if (isOneTimeInput(checkedInput)) return 'one_time';
        if (isSubscribeInput(checkedInput)) return 'subscribe';
      }
      return null;
    }
  
    function getHeadsPlan() {
      var input = document.querySelector('input[data-bundle-option]:checked');
      if (!input || !input.dataset.optionValue) return null;
      return normalizeValue(input.dataset.optionValue);
    }
  
    function getDeviceColour() {
      var input = document.querySelector('.product_variant_option[data-option-name*="olour"] input[type="radio"]:checked');
      return (input && input.dataset.optionValue) ? normalizeValue(input.dataset.optionValue) : null;
    }
  
    function getMainItemVariant() {
      var caseInput = document.querySelector('input[data-bundle-option]:checked');
      var caseValue = caseInput && caseInput.dataset.optionValue ? caseInput.dataset.optionValue : null;
      var colourInput = document.querySelector('.product_variant_option[data-option-name*="olour"] input[type="radio"]:checked');
      var colourValue = colourInput && colourInput.dataset.optionValue ? colourInput.dataset.optionValue : null;
      if (caseValue && colourValue) return caseValue + ' / ' + colourValue;
      if (caseValue) return caseValue;
      if (colourValue) return colourValue;
      return null;
    }
  
    function buildGA4Items() {
      var items = [];
      var totalValue = 0;
      var productTitle = getProductTitle();
      var selectedInputs = document.querySelectorAll('input[data-product-selection]:checked');
  
      for (var i = 0; i < selectedInputs.length; i++) {
        var input = selectedInputs[i];
        if (input.dataset.available === 'false') continue;
        if (input.hasAttribute('data-options-unselected')) continue;
        if (input.classList.contains('no-subscription-input')) continue;
  
        var rawId = input.value;
        var variantId = /^\d+$/.test(rawId) ? rawId : (input.dataset.variantId || rawId);
        var isMain = isMainProductVariant(variantId);
        var priceRaw = parseInt(input.dataset.price || '0', 10);
        var quantity = parseInt(input.dataset.quantity || '1', 10);
        var price = isNaN(priceRaw) ? 0 : priceRaw / 100;
        var qty = isNaN(quantity) ? 1 : quantity;
  
        items.push({
          item_id: isMain ? getVariantSku(variantId) : variantId,
          item_name: isMain ? productTitle : (input.dataset.bbLineTitle || null),
          item_variant: isMain ? (getVariantTitle(variantId) || getMainItemVariant()) : null,
          price: price,
          quantity: qty
        });
  
        totalValue += price * qty;
      }
  
      return { items: items, value: Math.round(totalValue * 100) / 100 };
    }
  
    function init() {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-product-atc]');
        if (!btn) return;
        if (btn.disabled) return;
  
        var result = buildGA4Items();
  
        if (window.Shopify && window.Shopify.analytics) {
          window.Shopify.analytics.publish('leaf_prevent_atc', {});
        }
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'add_to_cart_sonic_brush',
          ecommerce:{
            currency: CURRENCY,
            value: result.value,
            items: result.items
          },
          plan_type: getPlanType(),
          heads_plan: getHeadsPlan(),
          device_colour: getDeviceColour(),
          
        });
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  // Leaf - Event - add_to_cart_sonic_brush - End
  